export const customZIndex = {
    // Local layout (below sticky elements like nav/jumpMarksBar)
    contentMenu: 9,
    jumpMarksBar: 10,
    toast: 1600,
} as const;

export type TCustomZIndex = typeof customZIndex;
